// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const SummonButton = () => ({
   replace: true,
   templateUrl: '/assets/shared/summonButton.html',
   controllerAs: 'sb',
   controller: SummonButtonController,

   bindToController: {
      dotCode: '<',
      displayText: '<',
      hoverText: '<',
      toggle: '<'
   }
})

const SummonLink = () => ({
   replace: true,
   templateUrl: '/assets/shared/summonLink.html',
   controllerAs: 'sl',
   controller: SummonLinkController,

   bindToController: {
      link: '<',
      displayText: '<',
      hoverText: '<',
      icon: '<',
      dotCode: '<',
      loadStatus: '<',
      internalRedirect: '<',
      iconRight: '<',
   }
})

const SummonDropdown = () => ({
   replace: true,
   templateUrl: '/assets/shared/summonDropdown.html',
   controllerAs: 'vm',
   controller: SummonLinkController,

   bindToController: {
      primaryLink: '<',
      options: '<',
      displayText: '<',
      linkClickEvent: '&',
      primaryLinkLabel : '<',
      dotCode: '<'
   }
})

const SummonCheckbox = () => ({
   replace: true,
   templateUrl: '/assets/shared/summonCheckbox.html',
   controllerAs: 'sc',
   controller: SummonCheckboxController,

   bindToController: {
      isSelected: '<',
      isDisabled: '<',
      hoverText: '<',
      scLabel: '<',
      inputId: '<',
      toggle: '&'
   }
})

class SummonButtonController {
   $scope: any
   constructor($scope: any) {
      this.$scope = $scope
   }
}

class SummonLinkController {
   $scope: any
   i18n: any
   directLink: string
   constructor($scope: any, translationService: any) {
      this.$scope = $scope
      this.i18n = translationService  
      this.directLink = this.$scope.vm.doc?.link_to_pdf || this.$scope.vm.doc?.link_to_unpaywall
   }

}

class SummonDropdownController {
   $scope: any
   i18n: any
   constructor($scope: any, translationService: any) {
      this.$scope = $scope
      this.i18n = translationService
   }
}

class SummonCheckboxController {
   $scope: any
   i18n: any
   constructor($scope: any, translationService: any) {
      this.$scope = $scope
      this.i18n = translationService
   }
}

SummonButtonController.$inject = ['$scope']
SummonLinkController.$inject = ['$scope']
SummonDropdownController.$inject = ['$scope']
SummonCheckboxController.$inject = ['$scope']


angular.module('summonApp.directives')
   .directive('summonButton', SummonButton)
   .directive('summonLink', SummonLink)
   .directive('summonDropdown', SummonDropdown)
   .directive('summonCheckbox', SummonCheckbox)
